export function downloadCSV(filePrefix: string, recordset: any[]) {
  if (!recordset || !recordset.length) {
    return;
  }
  const headerKeys = Object.keys(recordset[0]);
  const header = headerKeys.join(',');
  const csvRows = [header];
  recordset.forEach(row => {
    // Row is an object with all header keys
    const values = headerKeys.map(key => {
      let value = row[key];
      if (value === null || value === undefined) {
        value = '';
      }
      return `"${value.toString().replace(/"/g, '""')}"`;
    });
    csvRows.push(values.join(','));
  });
  const csvContent = csvRows.join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv' });
  const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
  const a = document.createElement('a');
  a.href = window.URL.createObjectURL(blob);
  a.download = `${filePrefix}_${timestamp}.csv`;
  a.click();
  window.URL.revokeObjectURL(a.href);
} 